const module = {
  routes: [
    {
      path: '/rebroadcasts/:id/logs',
      component: () => import('@/modules/rebroadcasts/pages/logs.vue'),
      meta: {
        layout: 'default',
        requiresAuth: true
      }
    },
    {
      path: '/rebroadcasts',
      component: () => import('@/modules/rebroadcasts/pages/index.vue'),
      children: [],
      meta: {
        layout: 'default',
        requiresAuth: true
      }
    }
  ]
};

export default module;
